export default {
  Model: {
    FORM_TYPE: 'formType',
    QUESTIONS: 'questions',
    KEY: 'key',
    TYPE: 'type',
    PROPERTY: 'property',
    ADJECTIVES: 'adjectives',
    NEGATIVE: 'negative',
    POSITIVE: 'positive',
    SUMMARIZED_QUESTION_KEY: 'summarizedQuestionKey',
    HEADER: 'header',
    OPTIONAL: 'optional',
    DESCRIPTION: 'description',
    PLACEHOLDER: 'placeholder',
    EXPLANATION_DESCRIPTION: 'explanationDescription',
    SHOW_EXPLANATION: 'showExplanation',
    SELF_REVIEW_DESCRIPTION: 'selfReviewDescription',
    VALUES: 'values',
    VISIBILITY: 'visibility',
    PRIVATE: 'private',
  },
};
